import React, { Component } from "react";
import MUIDataTable from "mui-datatables";
import { fetchCatDraugh, pushCatDraugh, delCatDraugh } from "../../api/portal";
import { pushLoader } from "../../actions/main";
import Button from "components/CustomButtons/Button.jsx";
import IconAdd from "@material-ui/icons/Add";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

class CatDraugh extends Component {
  constructor(props) {
    super(props);
    this.state = {
      datatable: [],
      openAdd: false,
      name: "",
      description: "",
      operation: "",
      draugh: 0
    };
  }

  UNSAFE_componentWillMount() {
    fetchCatDraugh()
      .then(response => {
        if (response != null) {
          this.setState({ datatable: response.data.results });
        }
      })
      .catch(error => {
        console.log(error);
        this.props.history.push("/pages/login#logout");
      });
  }

  handleRowSelect = e => {
    // console.log(e);
  };

  handleClose = (key, value) => {
    this.setState({
      [key]: value
    });
  };

  handleSave = () => {
    this.props.pushLoader(true);
    pushCatDraugh(this.state)
      .then(response => {
        this.props.pushLoader(false);
        this.handleClose("openAdd", false);
        fetchCatDraugh()
          .then(response => {
            if (response != null) {
              this.setState({ datatable: response.data.results });
            }
          })
          .catch(error => {
            console.log(error);
            this.props.history.push("/pages/login#logout");
          });
      })
      .catch(error => {
        console.log(error);
        this.props.history.push("/pages/login#logout");
      });
  };

  handleChangeName = e => {
    this.setState({ name: e.target.value });
  };

  handleChangeDescription = e => {
    this.setState({ description: e.target.value });
  };

  handleChangeOperation = e => {
    this.setState({ operation: e.target.value });
  };
  handleChangeDraugh = e => {
    this.setState({ draugh: e.target.value });
  };

  handleDelete = deletedRows => {
    const deletedIndexes = Object.keys(deletedRows.lookup);
    deletedIndexes.map(e => {
      const a = this.state.datatable[e];
      delCatDraugh(a.id)
        .then(response => {
          fetchCatDraugh()
            .then(response => {
              if (response != null) {
                this.setState({ datatable: response.data.results });
              }
            })
            .catch(error => {
              console.log(error);
              this.props.history.push("/pages/login#logout");
            });
        })
        .catch(error => {
          console.log(error);
          this.props.history.push("/pages/login#logout");
        });
    });
  };

  render() {
    const columns = [
      {
        name: "name",
        label: "Category Name",
        options: {
          filter: false,
          display: true
        }
      },
      {
        name: "description",
        label: "Description",
        options: {
          filter: false,
          display: true
        }
      },
      {
        name: "operation",
        label: "Operation",
        options: {
          filter: false,
          display: true
        }
      },
      {
        name: "draugh",
        label: "Draugh",
        options: {
          filter: false,
          display: true
        }
      }
    ];

    const options = {
      filter: false,
      search: true,
      selectableRows: "multiple",
      print: false,
      download: false,
      responsive: "scrollMaxHeight",
      viewColumns: false,
      onRowsDelete: this.handleDelete,
      onRowClick: e => {
        this.handleRowSelect(e);
      }
    };
    return (
      <div>
        <GridItem xs={12}>
          <Button
            onClick={() => this.handleClose("openAdd", true)}
            color="success"
            round
          >
            <IconAdd /> Add Category
          </Button>
        </GridItem>
        <br />
        <GridItem xs={12}>
          <MUIDataTable
            data={this.state.datatable}
            columns={columns}
            options={options}
          />
        </GridItem>
        <Dialog
          maxWidth={"md"}
          open={this.state.openAdd}
          onClose={() => this.handleClose("openAdd", false)}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">Add Category</DialogTitle>
          <DialogContent>
            <GridContainer>
              <GridItem xs={12} sm={12} md={12}>
                <CustomInput
                  labelText="Category Name"
                  id="name"
                  inputProps={{
                    value: this.state.name,
                    onChange: this.handleChangeName
                  }}
                  formControlProps={{
                    fullWidth: true
                  }}
                />
              </GridItem>
              <GridItem xs={12} sm={12} md={12}>
                <CustomInput
                  labelText="Description"
                  id="description"
                  inputProps={{
                    value: this.state.description,
                    onChange: this.handleChangeDescription
                  }}
                  formControlProps={{
                    fullWidth: true
                  }}
                />
              </GridItem>
              <GridItem xs={12} sm={12} md={12}>
                <CustomInput
                  labelText="Operation"
                  id="operation"
                  inputProps={{
                    value: this.state.operation,
                    onChange: this.handleChangeOperation
                  }}
                  formControlProps={{
                    fullWidth: true
                  }}
                />
              </GridItem>
              <GridItem xs={12} sm={12} md={12}>
                <CustomInput
                  labelText="Draugh"
                  id="draugh"
                  inputProps={{
                    value: this.state.draugh,
                    onChange: this.handleChangeDraugh,
                    type: "number"
                  }}
                  formControlProps={{
                    fullWidth: true
                  }}
                />
              </GridItem>
            </GridContainer>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleSave} color="success" round>
              Save
            </Button>
            <Button
              onClick={() => this.handleClose("openAdd", false)}
              color="danger"
              round
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

CatDraugh.propTypes = {
  pushLeftPanel: PropTypes.array,
  pushZonaTarget: PropTypes.string,
  pushPoiTarget: PropTypes.array,
  pushLoader: PropTypes.bool
};

function mapStateToProps(state) {
  return {
    token: state.token,
    blocking: state.loader,
    rightPanel: state.rightPanel,
    leftPanel: state.leftPanel
  };
}

export default withRouter(connect(
  mapStateToProps,
  { pushCatDraugh, pushLoader }
)(CatDraugh));
